import { render, staticRenderFns } from "./MonthlyConsumption_fpn.vue?vue&type=template&id=b701ce4c&"
import script from "./MonthlyConsumption_fpn.vue?vue&type=script&lang=js&"
export * from "./MonthlyConsumption_fpn.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyConsumption_fpn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports